import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationHideMailMagazineQuestion = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { hideMailMagazineQuestion } = viewModel;

	const isEdited = hideMailMagazineQuestion.isEdited;
	const hasError = Boolean(hideMailMagazineQuestion.error);

	const onSetHideMailMagazineQuestion = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "hideMailMagazineQuestion",
					value: {
						...hideMailMagazineQuestion,
						value: input,
					},
				},
			]);
		},
		[hideMailMagazineQuestion, onSetViewModel],
	);

	return {
		isEdited,
		hasError,

		hideMailMagazineQuestion,
		onSetHideMailMagazineQuestion,
	};
};
